export const ms = {
  'ad.label': 'Iklan',
  'ad.sponsored_by': 'Ditaja oleh {advertiser}',
  'ad.visit': 'Lawati',
  'cookies.preferences': 'Tetapan kuki',
  'cookies.title': 'Privasi anda, di bawah kawalan anda',
  'cookies.description': 'Kami menggunakan storan yang diperlukan supaya Albambam berfungsi. Kami hanya mendayakan analitik atau pemasaran dengan kebenaran anda. Anda boleh menariknya balik pada bila-bila masa. Baca',
  'cookies.privacy_link': 'Dasar Privasi',
  'cookies.close': 'Tutup tetapan',
  'cookies.necessary': 'Perlu',
  'cookies.necessary_desc': 'Sesi, keselamatan, bahasa dan tetapan asas.',
  'cookies.analytics': 'Analitik',
  'cookies.analytics_desc': 'Pengukuran penggunaan tanpa nama untuk menambah baik perkhidmatan.',
  'cookies.marketing': 'Pemasaran',
  'cookies.marketing_desc': 'Pemperibadian iklan dan pengukuran kempen.',
  'cookies.configure': 'Konfigurasi',
  'cookies.reject': 'Tolak pilihan',
  'cookies.save': 'Simpan pilihan',
  'cookies.accept': 'Terima semua',
  'lang.selector_label': 'Bahasa',
  'lang.changed': 'Bahasa ditukar',
  'nav.home': 'Laman Utama',
  'nav.categories': 'Kategori',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Persahabatan',
  'nav.upload': 'Muat Naik',
  'nav.profile': 'Profil',
  'nav.login': 'Log masuk',
  'common.signed_in': 'Log masuk berjaya',
  'common.error': 'Ralat',
  'topbar.search_placeholder': 'Cari video, pencipta...',
  'legal.terms': 'Terma',
  'legal.privacy': 'Privasi',
  'nav.admin': 'Pentadbiran',
  'nav.logout': 'Log keluar',
  'admin.tab.payments': 'Pembayaran',
  'admin.payments.title': 'Pembayaran',
  'cats.title': 'Kategori',
  'cats.all': 'Semua',
  'cats.adult_title': 'Kategori 18+',
  'cats.empty': 'Tiada video dalam kategori ini.',
  'friends.block_confirm': 'Sekat rakan ini? Anda tidak lagi boleh berbual atau melihat satu sama lain sebagai rakan.',
  'friends.accepted': 'Anda kini berkawan!',
  'friends.title': 'Persahabatan',
  'friends.subtitle': 'Hanya orang yang saling mengikuti menjadi rakan dan boleh berbual secara peribadi.',
  'friends.unread_count_label': '{n} mesej untuk dibaca',
  'friends.blocked_users_title': 'Pengguna disekat',
  'friends.unblock_user': 'Nyahsekat',
  'friends.requests_title': 'Permintaan sembang',
  'friends.request_badge': 'Permintaan',
  'friends.request_accept': 'Terima',
  'friends.request_ignore': 'Abaikan',
  'friends.empty_title': 'Belum ada rakan',
  'friends.empty_subtitle': 'Ikuti seseorang dan dapatkan ikutan balas untuk membuka sembang peribadi.',
  'friends.attach_image': 'Foto',
  'friends.shared_video_label': 'Kongsi video',
  'friends.select_conversation': 'Pilih rakan untuk mula berbual',
  'friends.block_user': 'Sekat',
  'friends.no_messages_yet': 'Belum ada mesej. Beri salam!',
  'friends.message_placeholder': 'Tulis mesej...',
  'section.trending': 'Sohor Kini',
  'section.shorts': 'Shorts',
  'section.for_you': 'Untuk anda',
  'home.hero.badge': 'Selamat datang ke Albambam',
  'home.hero.title_1': 'Video pendek.',
  'home.hero.title_2': 'Pencipta sebenar.',
  'home.hero.subtitle': 'Tonton, kongsi dan jana pendapatan. Muat naik video anda dan temui bakat baharu dalam setiap kategori.',
  'home.hero.cta_shorts': 'Tonton Shorts',
  'home.hero.cta_trending': 'Sohor Kini',
  'home.shorts.see_all': 'Lihat semua',
  'home.empty.title': 'Belum ada video',
  'home.empty.subtitle': 'Apabila pencipta memuat naik kandungan, ia akan dipaparkan di sini.',
  'live.send_diamonds': 'Hantar berlian',
  'live.buy': 'Beli',
  'live.chat': 'Sembang',
  'live.type_message': 'Taip mesej...',
  'live.send': 'Hantar',
  'auth.success_google': 'Log masuk dengan Google',
  'auth.fail_google': 'Sesi Google tidak sah',
  'auth.success_login': 'Log masuk berjaya',
  'auth.success_register': 'Akaun dicipta',
  'auth.login_tab': 'Log masuk',
  'auth.register_tab': 'Cipta akaun',
  'auth.email': 'E-mel',
  'auth.password': 'Kata laluan',
  'auth.submit_login_loading': 'Memuat masuk...',
  'auth.submit_login': 'Log masuk',
  'auth.name': 'Nama',
  'auth.submit_register_loading': 'Mencipta...',
  'auth.submit_register': 'Cipta akaun',
  'auth.or': 'atau',
  'legal.privacy_title': 'Dasar Privasi',
  'search.title': 'Hasil untuk \\u201c{q}\\u201d',
  'search.count': '{n} video',
  'search.empty': 'Tiada hasil.',
  'series.load_error': 'Siri tidak dapat dimuatkan',
  'series.unlocked': 'Siri dibuka',
  'series.purchase_error': 'Pembelian tidak dapat dimulakan',
  'series.restricted': 'Akses terhad',
  'series.configure_access': 'Konfigurasi akses',
  'series.language_all': 'Semua bahasa',
  'series.episode_count': '{n} episod',
  'series.buy': 'Beli siri',
  'series.filter_language': 'Tapis mengikut bahasa',
  'series.no_episodes': 'Belum ada episod diterbitkan.',
  'series.episode_number': 'Episod {n}',
  'legal.terms_title': 'Terma dan Syarat',
  'lang.ca': 'Catalan',
  'lang.en': 'Inggeris',
  'lang.es': 'Sepanyol',
  'lang.fr': 'Perancis',
  'lang.de': 'Jerman',
  'lang.it': 'Itali',
  'lang.eu': 'Basque',
  'lang.gl': 'Galicia',
  'lang.zh': 'Cina',
  'lang.other': 'Lain-lain',
  'lang.vi': 'Vietnam',
  'lang.ja': 'Jepun',
  'lang.ko': 'Korea',
  'lang.ru': 'Rusia',
  'lang.ro': 'Romania',
  'lang.ar': 'Arab',
  'lang.tr': 'Turki',
  'lang.pl': 'Poland',
  'lang.ms': 'Melayu',
  'lang.ta': 'Tamil',
  'upload.series_title_error': 'Masukkan tajuk siri',
  'upload.series_adult_category_error': 'Pilih kategori 18+ untuk siri',
  'upload.series_created': 'Siri dicipta',
  'upload.series_create_error': 'Siri tidak dapat dicipta',
  'upload.err_file': 'Pilih fail video yang sah',
  'upload.err_title': 'Tetapkan tajuk',
  'upload.series_select_error': 'Pilih atau cipta siri',
  'upload.trailer_target_error': 'Pilih video treler atau siri',
  'upload.price_error': 'Masukkan harga sah sekurang-kurangnya EUR 0.50.',
  'upload.adult_category_error': 'Pilih kategori dewasa',
  'upload.success': 'Video dimuat naik',
  'upload.title_h': 'Muat naik video',
  'upload.kind': 'Jenis siaran',
  'upload.kind_video': 'Video tersendiri',
  'upload.kind_episode': 'Episod siri',
  'upload.kind_trailer': 'Treler Shorts awam',
  'upload.series': 'Siri',
  'upload.series_select': 'Pilih siri',
  'upload.episode': 'Episod',
  'upload.series_new_title': 'Tajuk siri baharu',
  'upload.series_create': 'Cipta siri',
  'upload.series_adult': 'Siri 18+',
  'upload.series_premium': 'Siri premium',
  'upload.series_adult_category': 'Kategori 18+ siri',
  'upload.series_price': 'Harga episod dan pakej (EUR)',
  'upload.trailer_for': 'Treler mempersembahkan',
  'upload.trailer_select': 'Pilih video atau siri',
  'upload.video_prefix': 'Video',
  'upload.file_label': 'Fail video (MP4, maks 1GB)',
  'upload.file_pick': 'Klik untuk memilih video',
  'upload.thumb_label': 'Imej kecil (pilihan)',
  'upload.video_title': 'Tajuk',
  'upload.description': 'Penerangan',
  'upload.category': 'Kategori',
  'upload.is_short': 'Adakah Short (menegak)',
  'upload.paid_video': 'Video berbayar',
  'upload.adult_content': 'Kandungan 18+',
  'upload.video_language': 'Bahasa video',
  'upload.individual_price': 'Harga untuk menonton video ini (EUR)',
  'upload.paid_video_help': 'Penonton membeli akses kekal untuk video ini sahaja. Harga minimum ialah EUR 0.50.',
  'upload.adult_category': 'Kategori dewasa',
  'upload.uploading': 'Memuat naik {n}%',
  'upload.submit': 'Muat naik video',
  'user.followers': 'pengikut',
  'user.following': 'mengikuti',
  'user.follow': 'Ikuti',
  'user.chat_open': 'Sembang',
  'user.request_sent': 'Permintaan dihantar',
  'user.send_message': 'Hantar mesej',
  'user.followers_title': 'Pengikut',
  'user.following_title': 'Mengikuti',
  'user.unfollow': 'Nyahikut',
  'user.request_title': 'Permintaan sembang',
  'user.request_subtitle': 'Anda hanya boleh menghantar satu mesej. Jika mereka menerima permintaan anda, anda akan menjadi rakan dan boleh berbual.',
  'user.request_placeholder': 'Tulis mesej anda...',
  'user.request_send': 'Hantar permintaan',
  'shorts.login_for_like': 'Log masuk untuk suka',
  'watch.share_copied': 'Pautan disalin',
  'watch.delete_confirm': 'Padam komen ini?',
  'ad.skip_in': 'Langkau dalam {n}s',
  'ad.skip': 'Langkau iklan',
  'watch.share': 'Kongsi',
  'friends.share_video': 'Kongsi video',
  'friends.send': 'Hantar',
  'watch.comments': 'Komen',
  'watch.write_comment': 'Tulis komen...',
  'watch.publish': 'Terbitkan',
  'watch.login_to_comment': 'Log masuk untuk komen.',
  'watch.login_btn': 'Log masuk untuk komen',
  'watch.no_comments': 'Belum ada komen.',
  'watch.related': 'Berkaitan',
  'nav.trending': 'Sohor Kini',
  'friends.follow_option_only_follow': 'Ikuti',
  'friends.follow_option_friends': 'Rakan',
  'watch.like': 'Suka',
  'watch.views_short': '{n} tontonan',
  'shorts.empty.title': 'Belum ada Shorts',
  'shorts.empty.subtitle': 'Muat naik video pendek untuk memulakan bahagian ini.',
  'shorts.share': 'Kongsi',
  'auth.continue_google': 'Teruskan dengan Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Harga (€)',
  'upload.err_select': 'Pilih video',
  'profile.upload_btn': 'Muat naik video',
  'profile.tab_videos': 'Video saya ({n})',
  'profile.tab_history': 'Sejarah',
  'profile.tab_recos': 'Cadangan',
  'profile.no_videos': 'Anda belum memuat naik sebarang video.',
  'profile.no_history': 'Anda belum menonton sebarang video.',
  'profile.no_recos': 'Tonton beberapa video untuk menerima cadangan.',
  'profile.likes': 'suka',
  'profile.views': 'tontonan',
  'wallet.title': 'Dompet',
  'wallet.rate_label': 'Kadar',
  'wallet.min_label': 'Pengeluaran minimum',
  'wallet.amount_label': 'Jumlah untuk dikeluarkan',
  'wallet.withdraw_btn': 'Minta pengeluaran',
  'wallet.history_title': 'Sejarah pengeluaran',
  'wallet.success': 'Permintaan dicipta',
  'wallet.bad_amount': 'Jumlah tidak sah',
  'wallet.per_view': '{rate} {cur}/tontonan',
  'admin.title': 'Pentadbiran',
  'admin.stats.users': 'Pengguna',
  'admin.stats.videos': 'Video',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Tontonan',
  'admin.tab.videos': 'Video',
  'admin.tab.ads': 'Iklan',
  'admin.tab.users': 'Pengguna',
  'admin.tab.withdrawals': 'Pengeluaran',
  'admin.tab.config': 'Tetapan',
  'admin.tab.translations': 'Terjemahan',
  'tbl.title': 'Tajuk',
  'tbl.creator': 'Pencipta',
  'tbl.category': 'Kategori',
  'tbl.type': 'Jenis',
  'tbl.views': 'Tontonan',
  'tbl.likes': 'Suka',
  'tbl.status': 'Status',
  'tbl.actions': 'Tindakan',
  'tbl.placement': 'Penempatan',
  'tbl.advertiser': 'Pengiklan',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Klik',
  'tbl.active': 'Aktif',
  'tbl.name': 'Nama',
  'tbl.email': 'E-mel',
  'tbl.role': 'Peranan',
  'tbl.wallet': 'Dompet',
  'tbl.amount': 'Jumlah',
  'tbl.date': 'Tarikh',
  'tbl.user': 'Pengguna',
  'video.video': 'Video',
  'video.short': 'Short',
  'action.show': 'Terbitkan',
  'action.hide': 'Sembunyi',
  'action.delete_confirm_video': 'Padam video?',
  'ad.create_h': 'Cipta iklan',
  'ad.title_label': 'Tajuk',
  'ad.image_label': 'URL imej',
  'ad.target_label': 'URL sasaran',
  'ad.advertiser_label': 'Pengiklan',
  'ad.placement_label': 'Penempatan',
  'ad.placement.banner': 'Banner (laman)',
  'ad.placement.preroll': 'Pre-roll (sebelum video)',
  'ad.placement.overlay': 'Tindanan (dalam video)',
  'ad.active': 'Aktif',
  'ad.create_btn': 'Cipta',
  'ad.success_create': 'Iklan dicipta',
  'ad.delete_confirm': 'Padam iklan?',
  'users.make_admin': 'Jadikan pentadbir',
  'users.remove_admin': 'Buang pentadbir',
  'wd.approve': 'Luluskan',
  'wd.reject': 'Tolak',
  'wd.mark_paid': 'Tanda dibayar',
  'wd.empty': 'Tiada permintaan',
  'cfg.title': 'Tetapan pembayaran',
  'cfg.rate_label': 'Bayaran setiap tontonan ({cur})',
  'cfg.min_label': 'Pengeluaran minimum ({cur})',
  'cfg.currency': 'Mata wang',
  'cfg.save': 'Simpan',
  'cfg.saved': 'Tetapan disimpan',
  'trans.title': 'Bahasa & terjemahan',
  'trans.intro': 'Muat naik fail JSON dengan terjemahan untuk sebarang kod bahasa (cth. ja, pt, zh). Fail mesti mengandungi peta rata kunci → rentetan.',
  'trans.code_label': 'Kod bahasa (cth. ja, pt-BR, zh)',
  'trans.name_label': 'Nama paparan (dalam bahasa tersebut)',
  'trans.file_label': 'Fail JSON terjemahan',
  'trans.upload': 'Muat naik',
  'trans.uploaded': 'Terjemahan disimpan',
  'trans.delete': 'Padam',
  'trans.delete_confirm': 'Padam bahasa ini?',
  'trans.builtin': 'Terbina dalam',
  'trans.custom': 'Tersuai',
  'trans.empty_custom': 'Belum ada bahasa tersuai.',
  'common.cancel': 'Batal',
  'common.loading': 'Memuatkan...',
  'common.too_fast': 'Terlalu cepat, sila tunggu',
  'time.few_seconds': 'beberapa saat lalu',
  'time.min': '{n} min lalu',
  'time.h': '{n} j lalu',
  'time.d': '{n} h lalu',
  'time.w': '{n} mg lalu',
  'time.mo': '{n} bl lalu',
  'time.y': '{n} th lalu',
  'brand.tagline': 'Video pendek. Pencipta sebenar.',
  'live.section': 'Langsung',
  'live.start': 'Mula langsung',
  'live.end': 'Tamatkan langsung',
  'live.join': 'Sertai langsung',
  'live.chat_placeholder': 'Taip mesej...',
  'live.diamond': 'Berlian',
  'live.buy_access': 'Beli akses',
  'live.save_recording': 'Simpan rakaman',
};
